import React from 'react';
import { ITEMS_EQUIVALENT_TO_SPECIFIC_RAW_MATERIALS } from '../constant';
import {
  AllergyItem,
  AllergyMaster,
  PurchaseItemAllergyMaster,
} from '../models/PurchaseProcessedCalorieAllergySetting';
import { SPECIFIC_RAW_MATERIALS } from 'features/CalorieManagement/PartsConfigurationSetting/constant';
import AllergyItemSelect from './SelectItem';

interface PaginatedTableProps {
  rowsPerPage?: number;
  columnWidth: number[];
  purchaseItemAllergyMaster?: PurchaseItemAllergyMaster[];
  readonly: boolean;
  isApproved: boolean;
  allergyUnitItems: AllergyItem[];
  handleChangeAllergyItem: (event: React.ChangeEvent<HTMLSelectElement>, allergyMaster: AllergyMaster) => void;
  allergyType: typeof SPECIFIC_RAW_MATERIALS | typeof ITEMS_EQUIVALENT_TO_SPECIFIC_RAW_MATERIALS;
}

const AllergyTable = ({
  rowsPerPage = 10,
  columnWidth,
  purchaseItemAllergyMaster,
  readonly,
  isApproved,
  allergyUnitItems,
  handleChangeAllergyItem,
  allergyType,
}: PaginatedTableProps) => {
  const tables = [];
  const allergyMaster = purchaseItemAllergyMaster
    ?.filter((item) => item.allergy_master.type_name === allergyType)
    .sort((a, b) => a.allergy_master.display_order - b.allergy_master.display_order);
  if (!allergyMaster) return <></>;
  for (let i = 0; i < allergyMaster.length; i += rowsPerPage) {
    const chunk = allergyMaster.slice(i, i + rowsPerPage);
    tables.push(
      <div className="table table-responsive" key={i}>
        <div className="div-table fixsize-column purchase-detail-table">
          <div className="div-thead div-tr">
            {chunk.map((allergy, idx) => {
              return (
                <div
                  className="div-th d-flex align-items-center justify-content-center lh-1"
                  style={{ width: `${columnWidth[1]}rem` }}
                  key={idx}
                >
                  {allergy.allergy_master.allergy_name}
                </div>
              );
            })}
          </div>
          <div className="div-tr">
            {chunk.map((item, idx) => {
              return (
                <div
                  className="div-td d-flex align-items-center justify-content-center lh-2"
                  style={{
                    width: `${columnWidth[1]}rem`,
                    background: item.change_flg && !isApproved ? '#f8cecc' : '',
                  }}
                  key={idx}
                >
                  <AllergyItemSelect
                    value={item.allergy_item_master.allergy_item_cd}
                    options={allergyUnitItems}
                    readonly={readonly}
                    onChange={(e) => handleChangeAllergyItem(e, item.allergy_master)}
                    id={item.id}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {tables.map((table, index) => (
        <div key={index}>{table}</div>
      ))}
    </div>
  );
};

export default AllergyTable;
